import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  normalize() {
    const value = this.element.value.trim()
    
    if (value && !this.hasProtocol(value)) {
      this.element.value = `https://${value}`
    }
  }

  hasProtocol(url) {
    return /^[a-z]+:\/\//i.test(url)
  }
}
